





import { defineComponent, ref } from 'vue-demi';

export default defineComponent({
  name: 'MallContentLoading',
  components: {},
  setup(props, context) {
    const dotList = ref(new Array(8));
    return {
      dotList,
    };
  },
});
